{
    "name": "Anker",
    "version": "02.00.00.01",
    "force_update": "0",
    "description": "Anker configurations",
    "machine_model_list": [
        {
            "name": "Anker M5",
            "sub_path": "machine/Anker M5.json"
        },
        {
            "name": "Anker M5C",
            "sub_path": "machine/Anker M5C.json"
        }
    ],
    "process_list": [
        {
            "name": "fdm_process_common",
            "sub_path": "process/fdm_process_common.json"
        },
        {
            "name": "0.05mm Ultradetail @Anker",
            "sub_path": "process/0.05mm Ultradetail @Anker.json"
        },
        {
            "name": "0.10mm Detail @Anker",
            "sub_path": "process/0.10mm Detail @Anker.json"
        },
        {
            "name": "0.15mm Optimal @Anker",
            "sub_path": "process/0.15mm Optimal @Anker.json"
        },
        {
            "name": "0.20mm Standard @Anker",
            "sub_path": "process/0.20mm Standard @Anker.json"
        },
        {
            "name": "0.25mm Draft @Anker",
            "sub_path": "process/0.25mm Draft @Anker.json"
        },
        {
            "name": "0.30mm Superdraft @Anker",
            "sub_path": "process/0.30mm Superdraft @Anker.json"
        },
        {
            "name": "0.15mm Fast @Anker",
            "sub_path": "process/0.15mm Fast @Anker.json"
        },
        {
            "name": "0.20mm Fast @Anker",
            "sub_path": "process/0.20mm Fast @Anker.json"
        },
        {
            "name": "0.25mm Fast @Anker",
            "sub_path": "process/0.25mm Fast @Anker.json"
        }
    ],
    "filament_list": [
        {
            "name": "fdm_filament_common",
            "sub_path": "filament/fdm_filament_common.json"
        },
        {
            "name": "fdm_filament_abs",
            "sub_path": "filament/fdm_filament_abs.json"
        },
        {
            "name": "fdm_filament_asa",
            "sub_path": "filament/fdm_filament_asa.json"
        },
        {
            "name": "fdm_filament_pa",
            "sub_path": "filament/fdm_filament_pa.json"
        },
        {
            "name": "fdm_filament_pc",
            "sub_path": "filament/fdm_filament_pc.json"
        },
        {
            "name": "fdm_filament_pet",
            "sub_path": "filament/fdm_filament_pet.json"
        },
        {
            "name": "fdm_filament_pla",
            "sub_path": "filament/fdm_filament_pla.json"
        },
        {
            "name": "fdm_filament_pva",
            "sub_path": "filament/fdm_filament_pva.json"
        },
        {
            "name": "fdm_filament_tpu",
            "sub_path": "filament/fdm_filament_tpu.json"
        },
        {
            "name": "Generic ABS @Anker",
            "sub_path": "filament/Generic ABS @Anker.json"
        },
        {
            "name": "Generic ASA @Anker",
            "sub_path": "filament/Generic ASA @Anker.json"
        },
        {
            "name": "Generic PA @Anker",
            "sub_path": "filament/Generic PA @Anker.json"
        },
        {
            "name": "Generic PA-CF @Anker",
            "sub_path": "filament/Generic PA-CF @Anker.json"
        },
        {
            "name": "Generic PC @Anker",
            "sub_path": "filament/Generic PC @Anker.json"
        },
        {
            "name": "Generic PETG @Anker",
            "sub_path": "filament/Generic PETG @Anker.json"
        },
        {
            "name": "Generic PLA @Anker",
            "sub_path": "filament/Generic PLA @Anker.json"
        },
        {
            "name": "Generic PLA-CF @Anker",
            "sub_path": "filament/Generic PLA-CF @Anker.json"
        },
        {
            "name": "Generic PVA @Anker",
            "sub_path": "filament/Generic PVA @Anker.json"
        },
        {
            "name": "Generic TPU @Anker",
            "sub_path": "filament/Generic TPU @Anker.json"
        }
    ],
    "machine_list": [
        {
            "name": "fdm_machine_common",
            "sub_path": "machine/fdm_machine_common.json"
        },
        {
            "name": "Anker M5 0.4 nozzle",
            "sub_path": "machine/Anker M5 0.4 nozzle.json"
        },
        {
            "name": "Anker M5C 0.4 nozzle",
            "sub_path": "machine/Anker M5C 0.4 nozzle.json"
        }
    ]
}
